/* src/components/Header/Header.jsx */
import './Header.css'
import {useEffect, useState} from "react";
import {Button} from "../Button/Button.jsx";

const NAV = [
	{label: 'Про Avenue', href: '#about'},
	{label: 'Колекції', href: '#collections'},
	{label: 'Чому Avenue', href: '#why'},
	{label: 'Контакти', href: '#contacts'},
];

// зовнішні CTA-посилання
export const ORDER_URL = 'https://t.me/KovalskaOnlineBot';
export const SHOP_URL = 'https://shop.kovalska.com/paving-slabs/';

const Header = () => {
	const [open, setOpen] = useState(false);

	// блокуємо скрол сторінки, поки меню відкрите.
	// position:fixed замість overflow:hidden — iOS Safari ігнорує overflow
	// для тач-скролу, і фон під меню далі гортається
	useEffect(() => {
		if (!open) return;
		const y = window.scrollY;
		const b = document.body.style;
		b.position = 'fixed';
		b.top = `-${y}px`;
		b.left = '0';
		b.right = '0';
		b.width = '100%';
		b.overflow = 'hidden';
		return () => {
			b.position = '';
			b.top = '';
			b.left = '';
			b.right = '';
			b.width = '';
			b.overflow = '';
			window.scrollTo(0, y);   // повертаємо позицію, з якої відкрили меню
		};
	}, [open]);

	// закриття по Esc
	useEffect(() => {
		if (!open) return;
		const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
		window.addEventListener('keydown', onKey);
		return () => window.removeEventListener('keydown', onKey);
	}, [open]);

	return (
		<header className="header">
			<div className="header__container">
				<img src='/icons/logo.svg' className="header__logo" alt='Avenue від "Ковальської"' />

				{/* ДЕСКТОП: кнопки справа в шапці */}
				<div className="header__actions">
					<Button
						variant="secondary"
						size="sm"
						as="a"
						href={SHOP_URL}
						target="_blank"
						rel="noopener noreferrer"
						analyticsEvent="cta_click"
						analyticsParams={{location: "hero", label: "primary"}}
					>
						Всі товари
					</Button>
					<Button
						variant="primary"
						size="sm"
						as="a"
						href={ORDER_URL}
						target="_blank"
						rel="noopener noreferrer"
						analyticsEvent="cta_click"
						analyticsParams={{location: "hero", label: "secondary"}}
					>
						Замовити
					</Button>
				</div>

				{/* МОБІЛКА: бургер */}
				<button
					type="button"
					className="header__burger"
					aria-label="Відкрити меню"
					aria-expanded={open}
					onClick={() => setOpen(true)}
				>
					<span></span>
					<span></span>
					<span></span>
				</button>
			</div>

			{/* МОБ: повноекранне меню */}
			<div className={`header__menu${open ? ' is-open' : ''}`} role="dialog" aria-modal="true">
				<div className="header__menu-top">
					<img src='/icons/logo.svg' className="header__logo" alt='Avenue від "Ковальської"' />
					<button
						type="button"
						className="header__menu-close"
						aria-label="Закрити меню"
						onClick={() => setOpen(false)}
					>
						<span></span>
						<span></span>
					</button>
				</div>

				<nav className="header__menu-nav">
					{NAV.map((item) => (
						<a
							key={item.href}
							href={item.href}
							onClick={(e) => {
								e.preventDefault();
								setOpen(false);
								// скролимо ПІСЛЯ зняття лока: cleanup ефекту відновлює
								// позицію скролу в коміті ре-рендера, тож чекаємо тік
								setTimeout(() => {
									document.querySelector(item.href)?.scrollIntoView({behavior: 'smooth'});
									window.history.replaceState(null, '', item.href);
								}, 0);
							}}
						>
							{item.label}
						</a>
					))}
				</nav>

				<div className="header__menu-actions">
					<Button
						variant="primary"
						size="lg"
						as="a"
						href={ORDER_URL}
						target="_blank"
						rel="noopener noreferrer"
						analyticsEvent="cta_click"
						analyticsParams={{location: "menu", label: "order"}}
					>
						Замовити
					</Button>
					<Button
						variant="secondary"
						size="lg"
						as="a"
						href={SHOP_URL}
						target="_blank"
						rel="noopener noreferrer"
						analyticsEvent="cta_click"
						analyticsParams={{location: "menu", label: "all"}}
					>
						Всі товари
					</Button>
				</div>
			</div>
		</header>
	);
};

export default Header;